import { useEffect, useState } from 'react';
import { fetchTemperature, KNMI_STATIONS, convertToLocalTime } from '../services/api';
import { TemperatureData } from '../types/types';
import './TemperatureDisplay.css';
import warmImage from '../assets/jadriekwart.png';
import coldImage from '../assets/ijskoud.webp';

export const TemperatureDisplay = () => {
    const [data, setData] = useState<TemperatureData>({
        temperature: null,
        timestamp: null,
        isWarm: false
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const getTemperature = async () => {
            console.log('Starting temperature fetch...');
            try {
                const temps = await fetchTemperature(
                    KNMI_STATIONS.DE_BILT,
                    KNMI_STATIONS.DE_BILT.name
                );
                console.log('Received temperatures:', temps);

                if (temps && temps.length > 0) {

                    // Get the most recent temperature reading
                    const latestTemp = temps[temps.length - 1];
                    setData({
                        temperature: latestTemp.value,
                        timestamp: latestTemp.timestamp,
                        isWarm: latestTemp.value > 10.0
                    });
                } else {
                    setError('Kon temperatuur niet ophalen');
                }
            } catch (err) {
                setError('Er ging iets mis bij het ophalen van de data');
            } finally {
                setLoading(false);
            }
        };

        getTemperature();

        // Update temperature every 5 minutes
        const interval = setInterval(getTemperature, 5 * 60 * 1000);
        return () => clearInterval(interval);
    }, []);

    if (loading) return <div className="container">Loading...</div>;
    if (error) return <div className="container">Error: {error}</div>;

    return (
        <div className="container">
            <h1>Kan ik een driekwart broek aan?</h1>
            <div className="temperature">
                {data.temperature !== null && data.timestamp && (
                    <>
                        <p className="temp-value">{data.temperature.toFixed(1)}°C</p>
                        <p className="temp-time">
                            Gemeten om {convertToLocalTime(data.timestamp)} in De Bilt
                        </p>
                        <div className="weather-image">
                            <img
                                src={data.temperature > 10.0 ? warmImage : coldImage}
                                alt={data.temperature > 10.0 ? "Warm genoeg voor driekwart broek" : "Te koud voor driekwart broek"}
                            />
                        </div>
                        <p className={data.isWarm ? 'answer warm' : 'answer cold'}>
                            {data.isWarm ? 'JA!' : 'NEE!'}
                        </p>
                    </>
                )}
            </div>
        </div>
    );
};